<template>
    <div>
      <!--轮播-->
      <div class="banner-box">
        <!-- <img src="../../img/bg2.png" alt="" class="title">
        <p class="title_1">手机APP、微信公众号、微信小程序、网站建设一网打尽</p>
        <swiper class="wow animated fadeInUp d1"></swiper> -->
        <el-carousel trigger="click" height="700">
          <el-carousel-item>
            <img src="../../assets/01-shouye/03-banner3.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/01-shouye/02-banner2.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img src="../../assets/01-shouye/01-banner1.jpg" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="padding: 50px 200px;">
        <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
          <div style="margin-right: 40px;" class="color-243">OUR</div>
          <div class="color-243">STRENGTHS</div>
        </div>
        <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">我们的优势</div>
        <img style="height: 540px;" src="../../assets/01-shouye/04-gsys.jpg" alt="">
        <div style="font-size: 20px;width:100%;text-align:center;font-weight:600;">智慧领航，数字先行一一助力企业数字化转型，开启智慧未来，助您领跑行业</div>
      </div>
      <div style="padding: 50px 200px;">
        <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
          <div style="margin-right: 40px;" class="color-243">COMPANY</div>
          <div class="color-243">PROFILE</div>
        </div>
        <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">公司介绍</div>
        <img style="height: 540px;" src="../../assets/01-shouye/05-gsjj.jpg" alt="">
      </div>
      <div style="padding: 50px 200px;">
        <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
          <div style="margin-right: 40px;" class="color-243">COPYRIGHT</div>
          <div class="color-243">CERTIFICATE</div>
        </div>
        <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">著作权登记证书</div>
        <el-carousel indicator-position="none" :interval="4000" trigger="click" type="card" height="400px">
          <el-carousel-item v-for="item in 3" :key="item">
            <img style="height: 100%;" src="../../assets/01-shouye/06-zzq.jpg" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div style="padding: 50px 200px;">
        <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
          <div style="margin-right: 40px;" class="color-243">COPYRIGHT</div>
          <div class="color-243">CERTIFICATE</div>
        </div>
        <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">企业资质</div>
        <el-carousel indicator-position="none" :interval="4000" trigger="click" type="card" height="400px">
          <el-carousel-item>
            <img style="height: 75%;" src="../../assets/01-shouye/2022gxjsqyzs.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img style="height: 75%;" src="../../assets/01-shouye/xjrzs.jpg" alt="">
          </el-carousel-item>
          <el-carousel-item>
            <img style="height: 100%;" src="../../assets/01-shouye/gdzjtjzs.jpg" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <foot></foot>
    </div>
</template>
<script>
import Swiper from 'swiper';
import swiper from '../../components/swiper'
import swiperCover from '../../components/swiperCover'
import h2Title from '../../components/h2Title'
import foot from '../../components/foot'
import {WOW} from 'wowjs'
export default {
  name: 'index',
  components:{
    swiper,
    h2Title,
    swiperCover,
    foot
  },
  data(){
    return{
       tabPosition: 'left',
       limit:'',
       list:[],
       company_name:'',
       description:'',
       partener:'',
       logoimg:'',
       keyword:''
    }
  },
  methods:{
    caseLoad:function(){
      this.$axios.get('/api/cases/list?page=1&limit='+this.limit)
      .then((res) => {
        this.list = res.data.list
        this.$nextTick(() => {  // 下一个UI帧再初始化swiper
          this.swiperCover();
        });
      })
    },
    companyload:function(){
      this.$axios.get('/api/about/list')
      .then((res) => {
        var i = 4
        this.company_name = res.data.list[i].company_name
        this.keyword = res.data.list[i].keyword
        this.description = res.data.list[i].description
        this.$store.commit("Company",res.data.list[i])
        this.partener =res.data.list[i].company_imgsurlarr
        this.logoimg =res.data.list[i].logo_url
      })
    },
    swiperCover(){
      this.$refs.mychild.initSwiper()
    },
  },
  mounted(){
    new WOW().init(); 
    this.caseLoad();
    this.companyload();
  }
}
</script>
<style lang="less" scoped>
.color-243 {
    color: rgb(243, 243, 243)
}

.color-97 {
    color: rgb(97, 97, 97)
}
/deep/ .el-carousel__container {
  height: 400px;
}
.swiper-container2 {
    width: 1200px;
    margin: 0px auto;
    height: 400px;
}  
  .el-main{
    padding:0px;
  }
  .banner-box{
    width:100%;
    // height: 800px;
    // background-color:#F4F4F4;
    // background-image:url('../../img/bg1.png');
    // background-position: center;
    // background-position-y:0px;
    // background-repeat:no-repeat;
  }
  .title{
    margin-top: 100px;
  }
  .title_1{
    color: #fff;
    font-size:16px;
    margin-top: 10px;
    text-shadow:2px 2px 6px rgba(0,0,0,.3);
  }
  .advantage{
    height: auto;
    background-image:url('../../img/bg3.png');
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: 0px;
    .bg{
      margin-top: 200px;
    }
    .advantage_box{
      background-color: #fff;
      width:100%;
      height:360px;
      margin: 60px auto 110px;
      .box1{
        width: 265px;
        height:360px;
        margin-right: 40px;
        float: left;
        background-image: url(../../img/bg5.png);
        background-repeat: no-repeat;
        text-align: left;
        font-size: 16px;
        .city{
          margin:50px 0px 0px 20px;
        }
        .company{
          margin:10px 0px 0px 20px;
          font-weight: 700;
        }
      }
      .box2{
        width:780px;
        float: left;
        .tab_advantage{
         .tab_advantage_box{
           text-align: left;
           .title{
             margin-top: 10px;
             margin-bottom: 10px;
             font-size: 24px;
             font-weight: 700;
           }
           .txt{
             font-size:16px;
             font-weight: 700;
             letter-spacing:3px;
           }
         }
        }
      }
    }
  }
  .case{
    height: 880px;
    background-image: url(../../img/bg7.png);
    background-repeat: no-repeat;
    background-position: center;
    background-position-y: 0px;
    display: flex;
    flex-direction: column;
    background-attachment: fixed;
  }
  .service{
    height: 745px;
    display: flex;
    flex-direction: column;
    .h1Title{
      margin-top: 80px;
    }
    .list{
      color:#333;
      margin-top: 75px;
      li{
        width:240px;
        position: relative;
        float: left;
        .img_jt{
          position: absolute;
          top: 40px;
          right: -30px;
        }
        &.animated:before{
            height:70px;
        }
        &:nth-child(1)::before{background-color: #6FD6FF;}
        &:nth-child(1)::after{background-color: #6FD6FF;}
        &:nth-child(2)::before{background-color: #FEB785;}
        &:nth-child(2)::after{background-color: #FEB785;}
        &:nth-child(3)::before{background-color: #91B7FF;}
        &:nth-child(3)::after{background-color: #91B7FF;}
        &:nth-child(4)::before{background-color: #FE6891;}
        &:nth-child(4)::after{background-color: #FE6891;}
        &:nth-child(5)::before{background-color: #BCB5FC;}
        &:nth-child(5)::after{background-color: #BCB5FC;}
         &:before{
            content: '';
            width:2px;
            height:70px;
            position: absolute;
            left:120px;
            top: 88px;
          }
        &:after{
            content: '';
            width:10px;
            height:10px;
            border-radius:100%;
            position: absolute;
            left:116px;
            top: 155px;
        }
        .img{
          position: relative;
        }
        .title{
          margin-top: 115px;
          font-size: 24px;
          font-weight: 700;
        }
        .txt{
          margin-top: 30px;
          line-height: 28px;
          font-size: 16px;
          color: #666;
        }
      }
    }
  }
  .company_box{
    height: 645px;
    background-image: url(../../img/bg8.png);
    background-position: center;
    background-position-y: 0px;
    background-repeat: no-repeat;
    .icon1{
      float: left;
      margin-left: 355px;
      margin-top: 230px;
      width: 200px;
      height: 200px;
    }
    .company_txt{
      width: 540px;
      height:340px;
      margin-top: 157px;
      background-color: #fff;
      border-radius: 50px;
      float: right;
      text-align: left;
      margin-right: -33px;
      h2{
        font-size: 24px;
        font-weight: 700;
        padding:40px 40px 15px 40px;
      }
      span{
        font-size:16px;
        padding-left: 40px;
        color:#666;
      }
      p{
        font-size: 16px;
        padding-left: 40px;
        padding-top: 20px;
        width:390px;
        line-height: 30px;
        font-weight: 700;
      }
      .more{
        width:110px;
        height: 35px;
        line-height: 35px;
        background-color: #187AFF;
        text-align: center;
        margin-left: 40px;
        margin-top: 30px;
        a{
          display: block;
          color:#fff;
          font-size: 16px;
        }
      }
    }
  }
  .partner{
    .h1Title{
      margin-top: 100px;
      margin-bottom: 60px;
    }
    .list{
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 100px;
      margin-left: -20px;
      li{
        width:calc(20% - 20px);
        margin-left: 20px;
        margin-bottom: 20px;
        .img_box{
          width:100%;
          height:100px;
          overflow: hidden;
          position: relative;
          img{
           width:100%;
           position: absolute;
           left:0px;
           top:0px;;
          }
        }
      }
    }
  }
</style>
<style lang="">
  .case .h1Title{
    color: #fff;
    margin-top: 80px;
  }
   #tab-0{
    background-color: #228bf9;
    position: relative;
  }
  #tab-0:after{
    content: '';
    width:100%;
    height:5px;
    background-color: #fff;
    position: absolute;
    bottom:0px;
    left:0px;
  }
  #tab-1:after{
    content: '';
    width:100%;
    height:5px;
    background-color: #fff;
    position: absolute;
    bottom:0px;
    left:0px;
  }
  #tab-2:after{
    content: '';
    width:100%;
    height:5px;
    background-color: #fff;
    position: absolute;
    bottom:0px;
    left:0px;
  }
  #tab-3:after{
    content: '';
    width:100%;
    height:5px;
    background-color: #fff;
    position: absolute;
    bottom:0px;
    left:0px;
  }
   #tab-1{
    background-color: #88daf2;
  }
   #tab-2{
    background-color: #64aefb;
  }
   #tab-3{
    background-color: #88daf2;
  }
  .el-tabs__item:hover{
    color:#fff;
  }
  .el-tabs__item.is-active{
    color: #fff;
  }
  .el-tabs__item{
    width:85px!important;
    height:90px!important;
    line-height: 90px!important;
    text-align: center!important;
    font-size: 36px!important;
    color:#fff!important;
  }
  .el-tabs__nav-wrap{
    overflow: visible!important;
  }
  .el-tabs__nav-scroll {
    overflow: visible!important;
}
  .el-tabs__active-bar.is-left{
    background:none!important;
    top:25px!important;
    right:-15px!important;
    width:0!important;
    height:0!important;
    border-width:15px 0 15px 15px;
    border-style:solid;
    border-color:transparent transparent transparent #ed6756;
  }
  .el-tabs__header.is-left{
    margin-right: 40px!important;
  }
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue